// without job
export const EXPERIENCE_FUNCTION = 'experience-function';
export const EXPERIENCE_CAREER_LEVEL = 'experience-career-level';
export const EXPERIENCE_INDUSTRIAL_SECTOR = 'experience-industrial-sector';
export const EXPERIENCE_FUNCTION_LEGAL_FIELD = 'experience-function-legal-field';
export const EXPERIENCE_FUNCTION_LEGAL_ROLE = 'experience-function-legal-role';
export const EXPERIENCE_FUNCTION_TAX_FIELD = 'experience-function-tax-field';
export const EXPERIENCE_FUNCTION_TAX_ROLE = 'experience-function-tax-role';
export const EXPERIENCE_FUNCTION_MARKETING_ROLE = 'experience-function-marketing-role';
export const EXPERIENCE_MANAGEMENT = 'experience-management';
export const EXPERIENCE_CUSTOMER_CONTACT = 'experience-customer-contact';
export const EXPERIENCE_ORGANISATIONAL_AREA = 'experience-organisational-area';
export const EDUCATION = 'education';
export const CAREER = 'career';
export const SKILLS = 'skills';
export const SKILLS_SOFTWARE_MAIN = 'skills-software-main';
export const SKILLS_SOFTWARE_SPECIAL = 'skills-software-special';
export const LANGUAGES = 'languages';
export const DRIVING_LICENSE = 'driving-license';
export const PILOT_LICENSE = 'pilot-license';

// with job
export const EMPLOYMENT_MODE = 'employment-mode';
export const EMPLOYMENT_DURATION = 'employment-duration';
export const NAME = 'name';
export const FUNCTION = 'function';
export const FUNCTION_ASSISTANCE = 'function-assistance';
export const FUNCTION_MARKETING_ROLE = 'function-marketing-role';
export const FUNCTION_LEGAL_FIELD = 'function-legal-field';
export const FUNCTION_LEGAL_ROLE = 'function-legal-role';
export const FUNCTION_TAX_FIELD = 'function-tax-field';
export const FUNCTION_TAX_ROLE = 'function-tax-role';
export const CAREER_LEVEL = 'career-level';
export const INDUSTRIAL_SECTOR = 'industrial-sector';
export const ORGANISATIONAL_AREA = 'organisational-area';
export const GEO = 'geo';
export const SEARCH_STATUS = 'search-status';
export const START_DATE = 'start-date';
export const COMPANY_TYPE = 'company-type';
export const COMPANY_SIZE = 'company-size';
export const CUSTOMER_CONTACT = 'customer-contact';
export const COMPANY_CAR = 'company-car';
export const PUBLIC_TRANSPORT = 'public-transport';
export const WORKING_TIME = 'working-time';
export const OVERTIME = 'overtime';
export const TRAVEL_WILLINGNESS = 'travel-willingness';
export const RELOCATION = 'relocation';
export const SALARY = 'salary';
export const HOURLY_RATE = 'hourly-rate';
export const PARKING = 'parking';
export const HOME_OFFICE = 'home-office';
export const WORKING_HOURS = 'working-hours';
export const PRIVATE_VEHICLE_COMPANY_USAGE = 'private-vehicle-company-usage';
export const MANAGEMENT = 'management';
export const CAREER_CHANGE_FUNCTION = 'career-change-function';
export const CAREER_CHANGE_INDUSTRIAL_SECTOR = 'career-change-industrial-sector';
export const LEGITIMATION = 'legitimation';
